import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// import "antd/dist/antd.css";
import { ConfigProvider } from 'antd';


ReactDOM.render(
  <React.StrictMode>
     <ConfigProvider  theme={{
                token: {
                    // Seed Token
                    colorPrimary: '#244384',
                    fontFamily:"Montserrat, sans serif"
                },
      components: {
        Button: {
            backgroundColor: '#f0f2f5',
          algorithm: true, // Enable algorithm
        }}
    }} >
    <App />
    </ConfigProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
